import React, { useState } from 'react';
import RotateLeftIcon from "@material-ui/icons/RotateLeft";
import RotateRightIcon from "@material-ui/icons/RotateRight";
import InnerImageZoom from "react-inner-image-zoom";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import GetAppIcon from '@material-ui/icons/GetApp';

const SingleImage = ({index, content, getValue, image, rotate, rotateLeft, rotateRight, saveImg,download,onClickImage = () => {}, imageDimension, imageZoomState}) => {

  const rotateIconStyles = {
    marginTop: '30px',
  }
  return (
    <div key={index}>
      {content ? <p>{content}</p> : null}
      <div style={{
        transform: `rotate(${rotate}deg)`,
        maxWidth: "100%",
        minHeight: imageDimension,
        margin: "auto",
        touchAction: "manipulation"
      }}>
        <InnerImageZoom
          src={getValue(image)?.image}
          zoomType="click"
          zoomPreload
          hasSpacer={true}
        />
      </div>
      <div style={{
        zIndex: 2000,
        margin: '20px 0'
      }}>
        <RotateLeftIcon onClick={rotateLeft} />
        <RotateRightIcon onClick={rotateRight} />
      <GetAppIcon  onClick={() => download(image)}/>
      </div>
    </div>
  )
}

export default SingleImage
